/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Growth_EyebrowInputs */

const en_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Growth of the Game`)
};

const es_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crecimiento del juego`)
};

const de_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachstum des Spiels`)
};

const zh_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`游戏的成长`)
};

const ar_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نمو اللعبة`)
};

const fr_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Croissance du jeu`)
};

const vi_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phát triển môn chơi`)
};

const sw_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukuaji wa Mchezo`)
};

const th_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเติบโตของเกม`)
};

const bs_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rast igre`)
};

const ja_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゴルフの普及`)
};

const ko_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`골프 저변 확대`)
};

const pt_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crescimento do golfe`)
};

const it_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La crescita del gioco`)
};

const sv_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillväxten av spelet`)
};

const nl_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groei van het spel`)
};

const da_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vækst i spillet`)
};

const nb_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spillets vekst`)
};

const fi_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelin kasvu`)
};

const pl_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wzrost gry`)
};

const ru_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рост игры`)
};

const tr_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyunun Büyümesi`)
};

const hi_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खेल का विकास`)
};

const id_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertumbuhan Permainan`)
};

const ms_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memajukan Sukan Golf`)
};

const cs_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Růst hry`)
};

const el_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ανάπτυξη του παιχνιδιού`)
};

const he_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הצמיחה של המשחק`)
};

const af_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groei van die spel`)
};

const hu_about_growth_eyebrow = /** @type {(inputs: About_Growth_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A játék növekedése`)
};

/**
* | output |
* | --- |
* | "Growth of the Game" |
*
* @param {About_Growth_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_growth_eyebrow = /** @type {((inputs?: About_Growth_EyebrowInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Growth_EyebrowInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_growth_eyebrow(inputs)
	if (locale === "de") return de_about_growth_eyebrow(inputs)
	if (locale === "zh") return zh_about_growth_eyebrow(inputs)
	if (locale === "ar") return ar_about_growth_eyebrow(inputs)
	if (locale === "fr") return fr_about_growth_eyebrow(inputs)
	if (locale === "vi") return vi_about_growth_eyebrow(inputs)
	if (locale === "sw") return sw_about_growth_eyebrow(inputs)
	if (locale === "th") return th_about_growth_eyebrow(inputs)
	if (locale === "bs") return bs_about_growth_eyebrow(inputs)
	if (locale === "ja") return ja_about_growth_eyebrow(inputs)
	if (locale === "ko") return ko_about_growth_eyebrow(inputs)
	if (locale === "pt") return pt_about_growth_eyebrow(inputs)
	if (locale === "it") return it_about_growth_eyebrow(inputs)
	if (locale === "sv") return sv_about_growth_eyebrow(inputs)
	if (locale === "nl") return nl_about_growth_eyebrow(inputs)
	if (locale === "da") return da_about_growth_eyebrow(inputs)
	if (locale === "nb") return nb_about_growth_eyebrow(inputs)
	if (locale === "fi") return fi_about_growth_eyebrow(inputs)
	if (locale === "pl") return pl_about_growth_eyebrow(inputs)
	if (locale === "ru") return ru_about_growth_eyebrow(inputs)
	if (locale === "tr") return tr_about_growth_eyebrow(inputs)
	if (locale === "hi") return hi_about_growth_eyebrow(inputs)
	if (locale === "id") return id_about_growth_eyebrow(inputs)
	if (locale === "ms") return ms_about_growth_eyebrow(inputs)
	if (locale === "cs") return cs_about_growth_eyebrow(inputs)
	if (locale === "el") return el_about_growth_eyebrow(inputs)
	if (locale === "he") return he_about_growth_eyebrow(inputs)
	if (locale === "af") return af_about_growth_eyebrow(inputs)
	if (locale === "hu") return hu_about_growth_eyebrow(inputs)
	return en_about_growth_eyebrow(inputs)
});